import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: "smallstack-form-control-dummy",
  templateUrl: "./form-control-dummy.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule]
})
export class FormControlDummyComponent {
  @Input()
  public control: UntypedFormControl;
}
